import React, { useEffect, useRef } from 'react'
import Chart from 'chart.js'
import BarColors from './BarColors'

const GroupedBarGraph = props => {
  let {
    labels,
    datasets,
    storeGraphRef,
    yAxesLabel,
    xAxesLabel,
    clickedDay,
    backToMonthView
  } = props
  const currentChart = useRef(null)
  const chartRef = useRef(null)
  labels = labels.map(label => label.split(' ')[0])
  useEffect(() => {
    currentChart.current = new Chart(chartRef.current, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: Object.keys(datasets).map(truckType => {
          return {
            data: datasets[truckType],
            backgroundColor: BarColors.getTruckColor(truckType),
            label: truckType
          }
        })
      },

      options: {
        events: ['mousemove'],
        onHover: (event, chartElement) => {
          event.target.style.cursor = chartElement[0] ? 'pointer' : 'default'
        },
        legend: {
          onClick: () => {}
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: yAxesLabel
              }
            }
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: xAxesLabel
              }
            }
          ]
        }
      }
    })
    storeGraphRef(currentChart.current)
    // eslint-disable-next-line
  }, [datasets])

  return (
    <canvas
      ref={chartRef}
      onClick={e => {
        if (xAxesLabel === 'Month-Day') clickedDay(currentChart.current.getElementAtEvent(e)[0])
        else backToMonthView()
      }}
    />
  )
}

export default GroupedBarGraph
